export const structure = {
    npk: '',
    total: 0,
    isLoaded: false,
    data: []
}

export default {
    legal: {},
    credit: {},
    project: {}, // project level uploads tab
    review: {},
    order: {}
}
